import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as signalR from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class WhatsAppOfficialRealtimeService {
  private hubConnection: signalR.HubConnection = null;
  private eventSource: EventSource = null;
  private guidclientenapis: string = null;
  private sellerId: number = null;
  private readonly eventosSubject = new Subject<any>();
  private readonly conexaoSubject = new Subject<boolean>();

  public conectar(guidclientenapis: string, sellerId: number): void {
    if (this.hubConnection != null) {
      return;
    }

    this.guidclientenapis = guidclientenapis;
    this.sellerId = sellerId;
    this.abrirEventSourceContingencia();

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl('/hubs/whatsapp-official')
      .withAutomaticReconnect()
      .build();

    this.hubConnection.on('update', evento => this.eventosSubject.next(evento));

    this.hubConnection.onreconnecting(() => {
      this.conexaoSubject.next(false);
    });

    this.hubConnection.onreconnected(() => {
      this.entrarNoTenant();
    });

    this.hubConnection.onclose(() => {
      this.conexaoSubject.next(false);
    });

    this.hubConnection.start()
      .then(() => this.entrarNoTenant())
      .catch(() => {
        this.conexaoSubject.next(false);
      });
  }

  public desconectar(): void {
    if (this.hubConnection == null) {
      return;
    }

    this.hubConnection.stop();
    this.hubConnection = null;
    this.fecharEventSourceContingencia();
    this.conexaoSubject.next(false);
  }

  public eventosAtualizados() {
    return this.eventosSubject.asObservable();
  }

  public estadoConexaoAtualizado() {
    return this.conexaoSubject.asObservable();
  }

  private entrarNoTenant(): void {
    if (this.hubConnection == null || !this.guidclientenapis || !this.sellerId) {
      this.conexaoSubject.next(false);
      return;
    }

    this.hubConnection.invoke('JoinTenant', this.guidclientenapis, this.sellerId)
      .then(() => this.conexaoSubject.next(true))
      .catch(() => {
        this.conexaoSubject.next(false);
      });
  }

  private abrirEventSourceContingencia(): void {
    if (this.eventSource != null || !this.guidclientenapis || !this.sellerId) {
      return;
    }

    this.eventSource = new EventSource('/api/WhatsAppOfficialRealtime/Subscribe?guidclientenapis=' + encodeURIComponent(this.guidclientenapis) + '&sellerId=' + encodeURIComponent(this.sellerId.toString()));

    this.eventSource.addEventListener('update', (event: MessageEvent) => {
      if (event == null || event.data == null || event.data == "") {
        return;
      }

      try {
        this.eventosSubject.next(JSON.parse(event.data));
      } catch {
        return;
      }
    });

    this.eventSource.onopen = () => {
      this.conexaoSubject.next(true);
    };
  }

  private fecharEventSourceContingencia(): void {
    if (this.eventSource == null) {
      return;
    }

    this.eventSource.close();
    this.eventSource = null;
  }
}
